import styled, { css } from 'styled-components'

export const AlertContent = styled.div<{ isVisible: boolean }>`
  text-align: center;
  ${({ isVisible }) =>
    isVisible &&
    css`
      animation: fadeIn 0.3s ease-in-out;
    `}

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`

export const AlertIcon = styled.img`
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  color: rgb(63, 108, 159);
`

export const AlertTitle = styled.h2`
  padding-top: 10px;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
  color: rgb(63, 108, 159);
`

export const AlertHtmlContent = styled.div`
  font-size: 16px;
  color: #666;
  margin-top: 20px;
  margin-bottom: 10px;
  line-height: 1.5;
`

export const AlertButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0 20px 20px;

  .alert-action-button {
    color: #fff;
    font-size: 16px;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    width: 100%;
  }

  .alert-later-button {
    background-color: transparent;
    color: rgb(82, 91, 101);
    font-size: 16px;
    padding: 10px 20px;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: transparent; /* Ensure no background on hover */
      color: #333; /* Dark gray text on hover */
      text-decoration: none; /* Remove underline on hover */
    }
  }
`
